var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoundingBoxWhite(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13719_4953",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13719_4953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33337 12.0007C4.96671 12.0007 4.65282 11.8701 4.39171 11.609C4.1306 11.3479 4.00004 11.034 4.00004 10.6673V2.66732C4.00004 2.30065 4.1306 1.98676 4.39171 1.72565C4.65282 1.46454 4.96671 1.33398 5.33337 1.33398H13.3334C13.7 1.33398 14.0139 1.46454 14.275 1.72565C14.5362 1.98676 14.6667 2.30065 14.6667 2.66732V10.6673C14.6667 11.034 14.5362 11.3479 14.275 11.609C14.0139 11.8701 13.7 12.0007 13.3334 12.0007H5.33337ZM5.33337 10.6673H13.3334V2.66732H5.33337V10.6673ZM2.66671 14.6673C2.30004 14.6673 1.98615 14.5368 1.72504 14.2757C1.46393 14.0145 1.33337 13.7007 1.33337 13.334V4.00065H2.66671V13.334H12V14.6673H2.66671Z",
    fill: "#FFFFFF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoundingBoxWhite);
export default __webpack_public_path__ + "static/media/bounding-box-white.baeebec8.svg";
export { ForwardRef as ReactComponent };